module.exports = __webpack_public_path__ + "media/artist.8cbd78af.webm";